import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToastrService } from 'ngx-toastr';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { PasswordValidator } from 'libs/portal/src/validators/password-validator';
import { Endpoints } from '@huge-monorepo/portal/config';
import { Location } from '@angular/common';
import { Routes } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-change-password-auth',
  templateUrl: './change-password-auth.component.html',
  styleUrls: ['./change-password-auth.component.scss'],
})
export class ChangePasswordAuthComponent implements OnInit {
  constructor(
    private genericService: GenericService,
    private router: Router,
    private toastService: ToastrService,
    private titleService: TitleService,
    private auth: UserRightsService,
    private endpoints: Endpoints,
    private _location: Location,
    private routes: Routes,
  ) {
    this.titleService.pageTitle = 'Change Password';
  }

  showSpinner = false;

  formGroup: UntypedFormGroup = new UntypedFormGroup(
    {
      passwordControl: new UntypedFormControl('', Validators.compose([Validators.minLength(6), Validators.required])),
      confirmPasswordControl: new UntypedFormControl('', [Validators.minLength(6), Validators.required]),
    },
    (formGroup: any) => {
      return PasswordValidator.areEqual(formGroup);
    },
  );

  validation_messages = {
    passwordControl: [
      { type: 'required', message: 'Password is required.' },
      {
        type: 'minlength',
        message: 'Please enter a password with more than 6 characters.',
      },
    ],
    matching_passwords: [{ type: 'areEqual', message: 'Password do not match.' }],
    confirmPasswordControl: [
      { type: 'required', message: 'Confirm password is required.' },
      {
        type: 'minlength',
        message: 'Please enter a password with more than 6 characters.',
      },
    ],
  };

  ngOnInit() {}

  resetPassword(): void {
    if (this.formGroup.status == 'INVALID') {
      this.formGroup.get('passwordControl').setErrors({ passwordMismatch: true });
    }
    if (
      this.formGroup.get('passwordControl').value == '' ||
      this.formGroup.get('confirmPasswordControl').value == '' ||
      this.formGroup.get('passwordControl').errors != null ||
      this.formGroup.get('confirmPasswordControl').errors != null
    ) {
      this.formGroup.get('passwordControl').markAsTouched();
      this.formGroup.get('confirmPasswordControl').markAsTouched();
    } else {
      this.genericService
        .PUT(this.endpoints.RESET_PASSWORD(this.auth.GetUID()), {
          password: this.formGroup.get('passwordControl').value,
        })
        .subscribe(() => {
          this.showSpinner = false;
          this.toastService.success('', 'Password successfully updated', { timeOut: 4000 });
          this.router.navigate([this.routes.Home]);
        });
    }
  }

  cancel() {
    this._location.back();
  }
}
